import { render, staticRenderFns } from "./TempDoctorSignup.vue?vue&type=template&id=72e24b42&scoped=true"
import script from "./TempDoctorSignup.vue?vue&type=script&lang=js"
export * from "./TempDoctorSignup.vue?vue&type=script&lang=js"
import style0 from "./TempDoctorSignup.vue?vue&type=style&index=0&id=72e24b42&prod&scoped=true&lang=css"
import style1 from "./TempDoctorSignup.vue?vue&type=style&index=1&id=72e24b42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e24b42",
  null
  
)

export default component.exports